import { render, staticRenderFns } from "./ProductsItemView.vue?vue&type=template&id=ccddf5f2&scoped=true&"
import script from "./ProductsItemView.vue?vue&type=script&lang=js&"
export * from "./ProductsItemView.vue?vue&type=script&lang=js&"
import style0 from "./ProductsItemView.vue?vue&type=style&index=0&id=ccddf5f2&lang=scss&scoped=true&"
import style1 from "./ProductsItemView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccddf5f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSheet})
